import api from "../utils/api";

export interface AlertThresholds {
  pendingApplications?: { warning: number; critical: number };
  unreadApplications?: { warning: number; critical: number };
  newActivity?: { warning: number; critical: number };
  unassigned?: { warning: number; critical: number };
}

export interface OverviewPreferences {
  defaultInboxUserIds: number[];
  statusCategorization?: {
    [decision_status_uuid: string]:
      | "approved"
      | "denied"
      | "canceled"
      | "review";
  };
  alertThresholds?: AlertThresholds;
  autoArchiveDays?: number;
}

export interface StatusWithDecision {
  uuid: string;
  title: string;
  decision: "review" | "approved" | "denied" | null;
  locked: boolean;
  deleted: boolean;
  financialInstitutionProduct?: {
    id: string;
    title: string;
  };
}

interface OverviewPreferencesResponse {
  dashboardPreferences: OverviewPreferences;
}

interface DecisionStatusesResponse {
  records: StatusWithDecision[];
}

/**
 * Fetch applications-overview preferences for an organization.
 */
export const fetchOverviewPreferences = async (
  organizationKey: string
): Promise<OverviewPreferencesResponse> => {
  const response = await api.get(
    `/organizations/${organizationKey}/submissions/dashboard/preferences`
  );
  return response.data;
};

/**
 * Fetch decision statuses for an organization
 */
export const fetchDecisionStatuses = async (
  organizationKey: string
): Promise<DecisionStatusesResponse> => {
  const response = await api.get(
    `/organizations/${organizationKey}/decision-statuses/all`
  );
  return response.data;
};

/**
 * Update applications-overview preferences for an organization.
 */
export const updateOverviewPreferences = async (
  organizationKey: string,
  preferences: OverviewPreferences
): Promise<OverviewPreferences> => {
  const response = await api.patch(
    `/organizations/${organizationKey}/submissions/dashboard/preferences`,
    { dashboardPreferences: preferences }
  );
  return response.data.dashboardPreferences;
};

/**
 * Fetch list of admins for user selection
 */
export const fetchAdmins = async (
  organizationKey: string
): Promise<Array<{ id: number; firstName: string; lastName: string }>> => {
  const response = await api.get(`/organizations/${organizationKey}/admins`);
  return response.data.records;
};
